import to from "@/lib/to";
import logger from "@/lib/logger";

export async function setVolume(volume, http, videoDeviceId) {
  logger.debug('setting device volume', { device_id: videoDeviceId, volume });
  if (volume >= 60 && volume <= 100) {
    if (videoDeviceId) {
      await to(http.post(`/video_devices/${videoDeviceId}/volume`, { volume }, {
        skipLoading: true,
        skipDivisions: true
      }));
    }
    return volume
  }
  return null
}